import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RecentSearchItem } from '../../models/results-types';

@Component({
  selector: 'recent-search-item',
  templateUrl: './recent-search-item.component.html',
  styleUrls: ['../../styles/results-typography.scss', './recent-search-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecentSearchItemComponent {
  @Input() model: RecentSearchItem;
  @Input() index: number;
  @Input() selected: boolean;
  @Output() clicked = new EventEmitter<RecentSearchItem>();
  @Input() keyboardOn: boolean;
}
